<template>
  <div class="mx-3">
    <v-row>
      <v-col
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <setup-payroll-perquisite-dialog-create
          v-if="$hasPermissionTo(['create perquisites'])" 
          @created="loadPerquisites"
        />
      </v-col>

      <v-spacer />

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-select
          v-model="statusFilter"
          :items="items"
          item-text="state"
          item-value="value"
          label="Persquisite's Status"
          placeholder="Active / Deleted"
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in perquisite here"
          append-icon="search"
          label="Search Persquisite"
          hide-no-data
          hide-selected
          clearable 
        />
      </v-col>
    </v-row>
  
    <v-data-table
      :headers="headers"
      :items="filteredPerquisites"
      :loading="tableLoading"
      :search="search"
    >
      <template v-slot:item.description="{ item }">
        <div
          v-if="item.description"
          v-html="item.description"
        />
        <div v-else>
          N/A
        </div>
      </template>

      <template v-slot:item.action="{ item }">
        <span v-if="statusFilter">
          <setup-payroll-perquisite-dialog-edit
            v-if="$hasPermissionTo(['update perquisites'])"
            :perquisite="item" 
            @updated="refreshData"
          />
          <span class="mx-1" />

          <setup-payroll-perquisite-dialog-delete
            v-if="$hasPermissionTo(['delete perquisites'])"
            :perquisite="item"
            @deleted="refreshData"
          />
        </span>
        <span v-else>
          <setup-payroll-perquisite-dialog-restore
            v-if="$hasPermissionTo(['restore perquisites'])"
            :perquisite="item"
            @restored="refreshData"
          />
        </span>
      </template>
    </v-data-table> 
  </div>
</template>

<script>
  export default {
    components: {
      SetupPayrollPerquisiteDialogCreate: () => import('@/components/hris/setup/payroll/perquisite/DialogCreate'),
      SetupPayrollPerquisiteDialogEdit: () => import('@/components/hris/setup/payroll/perquisite/DialogEdit'),
      SetupPayrollPerquisiteDialogDelete: () => import('@/components/hris/setup/payroll/perquisite/DialogDelete'),
      SetupPayrollPerquisiteDialogRestore: () => import('@/components/hris/setup/payroll/perquisite/DialogRestore'),
    },
    data () {
      return {
        perquisites: [],
        trashedPerquisites: [],
        headers: [
          {
            text: 'Name',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Description',
            align: 'left',
            value: 'description',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        search: '',
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        tableLoading: true,
      }
    },
    computed: {
      filteredPerquisites () {
        return this.statusFilter ? this.perquisites : this.trashedPerquisites
      },
    },
    created () {
      this.refreshData()
    },
    methods: {
      loadPerquisites () {
        this.$api.benefitInKinds().list('?filter[type]=perquisite')
          .then(response => {
            this.perquisites = response.data
            this.tableLoading = false
          })
      },
      loadTrashedPerquisites () {
        this.$api.benefitInKinds().listTrashed('?filter[type]=perquisite')
          .then(response => {
            this.trashedPerquisites = response.data
          })
      },
      refreshData () {
        this.loadPerquisites()
        this.loadTrashedPerquisites()
      },
    },
  }
</script>
